import { Constantes } from "../constant/constantes";

export class EncuestaSatisfaccion{
    private c:Constantes = new Constantes();

    calificacion:string='';
    razonCalificacion:string='';

    idSerie:number=0;
    nombreTematica:string='';
    fechaInicial:number = 0;
    fechaFinal:number = 0;
    productoOrigen!:string;

    tipoEncuesta:string='';

    accesibilidadDatos:string='';
    ordenDatos:string='';
    utilidadDatos:string='';

    actividadEconomica:string='';
    ocupacion:string='';
    propositoDatos:string='';
    frecuenciaConsultaDatos:string='';
}

